import type { ScriptLine } from "../../coldcompute";

// Caption lines are SCENE-LOCAL (fromSec resets to 0 inside each scene's <Sequence>).
// Opinion piece — every concrete claim is grounded in EAKC-MVP code/migrations or the
// 2026-05-27 company-brain positioning doc. Honesty boundary: the MCP brain (14 inbound
// tools) is SHIPPED; the packaging "gateway" (eakc-brain.md router, departments) is QUEUED.

export const HOOK: ScriptLine[] = [
  { scene: "hook", fromSec: 0.3, holdSec: 5.2, caption: "A big lab ships a no-code AI worker that anyone can install. Doesn't that kill my product?" },
];

export const REFRAME: ScriptLine[] = [
  { scene: "reframe", fromSec: 0.4, holdSec: 5.5, caption: "Here's the reframe I landed on: the no-code worker is the phone. My product is the memory it calls into." },
  { scene: "reframe", fromSec: 6.2, holdSec: 5, caption: "Don't fight the phone. Be the company brain every AI client talks to." },
  { scene: "reframe", fromSec: 11.5, holdSec: 4.5, caption: "Co-work, Cursor, Claude Code, ChatGPT — they're all terminals. The shared memory is the product." },
];

export const OVERLAP: ScriptLine[] = [
  { scene: "overlap", fromSec: 0.4, holdSec: 6, caption: "It feels like overlap until you ask where each one structurally lives." },
  { scene: "overlap", fromSec: 6.5, holdSec: 5.5, caption: "A no-code worker is single-user: plugin folders and Markdown files on one laptop." },
  { scene: "overlap", fromSec: 12.5, holdSec: 5, caption: "EAKC is multi-tenant and hosted: skills are rows in a table with a state machine and audit." },
];

export const MOAT: ScriptLine[] = [
  { scene: "moat", fromSec: 0.4, holdSec: 6, caption: "The moat isn't the chat box. It's the three things a folder-on-a-laptop can't do." },
  { scene: "moat", fromSec: 6.5, holdSec: 5.5, caption: "A drift detector that re-checks knowledge on every sync, and an output gate that blocks ungrounded answers." },
  { scene: "moat", fromSec: 12.5, holdSec: 5, caption: "Plus a skills state machine — proposed, active, pinned, archived — not a file you hand-edit." },
];

export const PROOF: ScriptLine[] = [
  { scene: "proof", fromSec: 0.4, holdSec: 6, caption: "And this isn't a roadmap. The brain is already an MCP server." },
  { scene: "proof", fromSec: 6.5, holdSec: 6.5, caption: "Fourteen inbound tools — query, sources, documents, graph — served from one route." },
  { scene: "proof", fromSec: 13.2, holdSec: 6, caption: "Connectors pull from GitHub, Gmail, Slack, Jira, Confluence, Drive — structured into a knowledge graph." },
];

export const GATEWAY: ScriptLine[] = [
  { scene: "gateway", fromSec: 0.4, holdSec: 6, caption: "So the move is to be the hosted, governed brain — and let any client connect over MCP." },
  { scene: "gateway", fromSec: 6.5, holdSec: 6, caption: "But I have to be honest: the packaging is mostly queued. The router file per tenant doesn't exist yet." },
  { scene: "gateway", fromSec: 12.5, holdSec: 4.5, caption: "The brain is shipped. The front door for it is a spec, not code." },
];

export const HONESTY: ScriptLine[] = [
  { scene: "honesty", fromSec: 0.4, holdSec: 6, caption: "Shipped: the MCP server, the gate, drift detection, skills, the integrations." },
  { scene: "honesty", fromSec: 6.5, holdSec: 5, caption: "Queued: the brain router, departments, the landing experience. I won't pretend otherwise." },
];

export const OUTRO: ScriptLine[] = [
  { scene: "outro", fromSec: 0.3, holdSec: 5, caption: "A no-code worker doesn't kill my product. It needs my product to be worth using." },
  { scene: "outro", fromSec: 5.5, holdSec: 3.8, caption: "Next: I audit my own product and label, honestly, what isn't done yet." },
];

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
